function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Grupo_1359",
  "data-name": "Grupo 1359"
}, /*#__PURE__*/React.createElement("g", {
  id: "Grupo_976",
  "data-name": "Grupo 976",
  transform: "translate(24 13.818) rotate(135)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Grupo_470",
  "data-name": "Grupo 470",
  transform: "translate(6.128 0)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Ret\\xE2ngulo_1388",
  "data-name": "Ret\\xE2ngulo 1388",
  width: 1.216,
  height: 18.687,
  fill: "#c9c4c4"
})), /*#__PURE__*/React.createElement("g", {
  id: "Grupo_471",
  "data-name": "Grupo 471",
  transform: "translate(0 12.019)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Caminho_836",
  "data-name": "Caminho 836",
  d: "M.849,0,6.809,5.814,12.617.005l.86.86L6.819,7.523,0,.87Z",
  transform: "translate(0 0)",
  fill: "#c9c4c4"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Grupo_1361",
  "data-name": "Grupo 1361"
}, /*#__PURE__*/React.createElement("g", {
  id: "Caminho_1100",
  "data-name": "Caminho 1100",
  transform: "translate(0)",
  fill: "none"
}, /*#__PURE__*/React.createElement("path", {
  d: "M19.2,0H4.8A4.8,4.8,0,0,0,0,4.8V19.2A4.8,4.8,0,0,0,4.8,24H19.2A4.8,4.8,0,0,0,24,19.2V4.8A4.8,4.8,0,0,0,19.2,0Z",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M 4.799999237060547 1 C 2.704669952392578 1 1 2.704669952392578 1 4.799999237060547 L 1 19.20000076293945 C 1 21.29533004760742 2.704669952392578 23 4.799999237060547 23 L 19.20000076293945 23 C 21.29533004760742 23 23 21.29533004760742 23 19.20000076293945 L 23 4.799999237060547 C 23 2.704669952392578 21.29533004760742 1 19.20000076293945 1 L 4.799999237060547 1 M 4.799999237060547 0 L 19.20000076293945 0 C 21.8509693145752 0 24 2.149030685424805 24 4.799999237060547 L 24 19.20000076293945 C 24 21.8509693145752 21.8509693145752 24 19.20000076293945 24 L 4.799999237060547 24 C 2.149030685424805 24 0 21.8509693145752 0 19.20000076293945 L 0 4.799999237060547 C 0 2.149030685424805 2.149030685424805 0 4.799999237060547 0 Z",
  stroke: "none",
  fill: "#c1bcbc"
}))));

function SvgMenuOpened(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "collapse",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuOpened);
export default __webpack_public_path__ + "static/media/menu-opened.46eb27e0.svg";
export { ForwardRef as ReactComponent };